
import React from 'react';
import { Button } from '@/components/ui/button';
import { RefreshCw } from 'lucide-react';
import { DateRange } from 'react-day-picker';
import { EnhancedDateRangePicker } from '@/components/ui/enhanced-date-range-picker';

interface EnhancedDateRangeSelectorProps {
  dateRange: DateRange | undefined;
  onDateRangeChange: (range: DateRange | undefined) => void;
  onRefresh: () => void;
  isLoading: boolean;
  className?: string;
}

const EnhancedDateRangeSelector: React.FC<EnhancedDateRangeSelectorProps> = ({
  dateRange,
  onDateRangeChange,
  onRefresh,
  isLoading,
  className = ''
}) => {
  return (
    <div className={`flex flex-wrap gap-3 items-center ${className}`}>
      <div className="flex-1 min-w-[300px]">
        <EnhancedDateRangePicker
          date={dateRange}
          setDate={onDateRangeChange}
          placeholder="Выберите период для анализа"
          maxDate={new Date()}
        />
      </div>
      
      <Button 
        onClick={onRefresh} 
        disabled={isLoading}
        className="flex items-center gap-2"
        variant="outline"
      >
        {isLoading ? <RefreshCw className="h-4 w-4 animate-spin" /> : <RefreshCw className="h-4 w-4" />}
        Обновить
      </Button>
    </div>
  );
};

export default EnhancedDateRangeSelector;
